import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import $ from "jquery";

export default class ModalWrapper extends React.Component
{
	constructor(props)
	{
		super(props);
	}

	componentDidMount()
	{
		$("body").addClass("modal-open");
	}

	componentWillUnmount()
	{
		$("body").removeClass("modal-open");
	}

	render()
	{
		return (
			<div>
				<Modal.Dialog className={this.props.modalClassName}>
					<Modal.Header className="bg-primary">
						<Modal.Title>{this.props.title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{this.props.children}
					</Modal.Body>
					<Modal.Footer className={this.props.footerClass}>
						{this.props.footerElements}
					</Modal.Footer>
				</Modal.Dialog>
				<div className="modal-backdrop fade in" />
			</div>
		);
	}
}

ModalWrapper.propTypes = {
	children: PropTypes.element,
	title: PropTypes.string,
	modalClassName: PropTypes.string,
	footerElements: PropTypes.arrayOf(PropTypes.element),
	footerClass: PropTypes.string
};



// WEBPACK FOOTER //
// ./Components/components/ModalWrapper.jsx